import { h } from 'preact';
import { now } from 'Misc/timing';
import BaseComponent from '../BaseComponent';
import './Toast.css';

const TIMEOUT = 2000;

export default class Toast extends BaseComponent {
  constructor() {
    super();
    this.lastRender = 0;
  }

  render(props) {
    if(props.display) {
      this.lastRender = now();
      return this.template;
    } else if(now() < this.lastRender + TIMEOUT) {
      return this.template;
    }

    return null;
  }

  get template() {
    return <div class="toast">Copied To Clipboard</div>;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/Toast/Toast.js